<div
  class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden"
>
  <mat-drawer-container class="flex-auto sm:h-full">
    <!-- Drawer sm:w-96 -->
    <mat-drawer
      class="dark:bg-gray-900"
      [ngClass]="{ 'w-full lg:w-2/4': drawerOpened }"
      [autoFocus]="false"
      [position]="drawerPosition"
      [mode]="drawerMode"
      [opened]="drawerOpened"
      #drawer
    >
      <!-- Main -->
      <div>
        <div>
          <mat-card class="modal">
            <mat-card-header>
              <mat-card-title class="text-lg font-medium">
                Add Roles</mat-card-title
              >
              <div class="spacer">&nbsp;</div>
              <button
                class="mini-form-field"
                mat-icon-button
                aria-label="close modal icon"
                matTooltip="Close"
                (click)="drawerOpened = false"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content class="my-4" fuseScrollbar>
              <form #addRole="ngForm" role="form">
                <div class="row">
                  <div class="col-lg-4 mt-6">
                    <!-- <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Role Name</mat-label>
                      <input
                        type="text"
                        id="RoleName"
                        matInput
                        name="roleName"
                        [disabled]="role.id"
                        appNameCheck
                        [(ngModel)]="role.name"
                        placeholder="Enter role name"
                      />
                    </mat-form-field> -->
                    <mat-form-field class="w-100 mb-4">
                      <mat-label>Role Name</mat-label>
                      <input
                        matInput
                        type="text"
                        required
                        name="roleName"
                        [disabled]="role.id"
                        [(ngModel)]="role.name"
                        placeholder="Enter Role name"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <mat-card class="mt-1 w-100 mat-elevation-z0">
                  <mat-card-header>
                    <mat-card-title class="fs1 fw2">
                      <mat-checkbox
                        name="selectDeselectall"
                        [(ngModel)]="checkAll"
                        value=""
                        color="primary"
                        matTooltip="Toggle Select All"
                      >
                        <span class="">Resources and Scopes</span>
                      </mat-checkbox>
                    </mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <!-- <ng-container
                      *ngIf="
                        resourceAccess && !Objectkeys(resourceAccess).length
                      "
                    >
                      <mat-card>
                        <p>Fetching roles information, Please wait...</p>
                        <p class="pt-3">
                          <img
                            src="/assets/images/loading.gif"
                            alt="Loading"
                            width="50px"
                          />
                        </p>
                      </mat-card>
                    </ng-container> -->
                    <ng-container>
                      <mat-card
                        class="mat-elevation-z8 mb-2"
                        *ngFor="let task of Objectkeys(resourceAccess)"
                      >
                        <mat-card-header>
                          <mat-card-title class="fs1 fw2">{{
                            task | uppercase
                          }}</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                          <mat-list dense class="bor-1 w-100">
                            <mat-list-item
                              class="bb-1"
                              *ngFor="let access of resourceAccess[task]"
                            >
                              <span>
                                <mat-checkbox
                                  name="{{ task }}{{ access.id }}"
                                  id="{{ task }}{{ access.id }}"
                                  class="mt-2"
                                  [checked]="access.value"
                                  [(ngModel)]="access.value"
                                  color="primary"
                                >
                                  <span class="ml-4">
                                    {{ access.name | uppercase }}</span
                                  >
                                </mat-checkbox>
                              </span>
                            </mat-list-item>
                          </mat-list>
                        </mat-card-content>
                      </mat-card>
                    </ng-container>
                  </mat-card-content>
                  <mat-card-footer>
                    <div class="d-flex align-items-center">
                      <button
                        mat-stroked-button
                        color="warn"
                        (click)="drawerOpened = false"
                      >
                        Cancel
                      </button>
                      <button
                        [disabled]="!role.name"
                        mat-raised-button
                        class="ml-2"
                        color="primary"
                      >
                        Save
                      </button>
                    </div>
                  </mat-card-footer>
                </mat-card>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-drawer>
    <!-- Drawer content -->
    <!--<mat-drawer-content class="flex flex-col " fuseScrollbar>
            <div class="w-auto rounded-2xl" fuseScrollbar>
                <stable aria-label="Assets Table" role="table" [sTableOptions]="deviTableOptions"
                        (hyperlinkCallback)="linkClick($event)"></stable>
            </div>
        </mat-drawer-content>-->
    <mat-drawer-content class="h-full">
      <div>
        <stable
          aria-label="Roles Table"
          role="table"
          [sTableOptions]="rolesTableOptions"
        ></stable>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
